import React from 'react'
import PropTypes from 'prop-types'

import FilterGroup from '@components/FilterGroup'
import { StatusFilter } from '@components/StatusFilter'

function ProjectStatusFilter ({ projectsListingStore }) {
  const { query, filter } = projectsListingStore

  return (
    <FilterGroup inView label='Project status' labelClass='code-label'>
      <StatusFilter
        type='project'
        selectedItems={query.statusIds}
        onChange={statusIds => {
          query.statusIds.replace(statusIds)
          filter()
        }}
      />
    </FilterGroup>
  )
}

ProjectStatusFilter.propTypes = {
  projectsListingStore: PropTypes.object
}

export default ProjectStatusFilter
